import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class POSService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/pos`,{params:searchParams});
    }

    get(id){
      return this.http.get(`${environment.baseUrl}/pos/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.baseUrl}/pos/`+id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/pos`,formData);
    }

    delete(id){
      return this.http.delete(`${environment.baseUrl}/pos/`+id);
    }

    getTransactions(id,date){
      return this.http.get(`${environment.baseUrl}/pos/`+id+`/zreport`,{params:{date:date}});
    }

}